<template>
  <v-container>
    <v-card v-on:keydown.stop>
      <v-card-subtitle>Summary</v-card-subtitle>
      <v-card-text>
        <general-textarea
          ref="summaryTextarea" dense rows="1" no-resize
          v-model="$data.$_summaryNote"
          v-on:input="$_updateHeight"
          v-on:blur="$_saveSummaryNote"
        >
        </general-textarea>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {
  TimelineSegmentId,
  NoteSegmentData,
  EditorDefinition,
  GeneralTextarea,
  referencePool,
  providedFunctions,
} from '@Scatt'

export default {
  editorDefinition: new EditorDefinition(
    'SummaryNoteEditor',
    'Summary',
  ),

  components: {
    GeneralTextarea,
  },

  props: {
    annotatorId: { type: String },
    annotatorName: { type: String },
    timelineDataSet: { type: Object },
  },

  watch: {
    $_summaryNoteSegment: {
      handler(newSummaryNoteSegment) {
        if (newSummaryNoteSegment) {
          this.$data.$_summaryNote = String(newSummaryNoteSegment.data.text);
        } else {
          this.$data.$_summaryNote = '';
        }
      },
      immediate: true,
    },

    $_noteTimelineDataIdByCurrentUser: {
      handler(newNoteTimelineDataIdByCurrentUser) {
        if (newNoteTimelineDataIdByCurrentUser === null) {
          this.generateNewHiddenTimelineData(
            NoteSegmentData,
            'Notes - ' + this.annotatorName,
            false,
          );
        }
      },
      immediate: true,
    },

    $_summaryNoteSegmentId: {
      handler(newSummaryNoteSegmentId) {
        if (newSummaryNoteSegmentId === null) {
          this.setNewSegment(
            this.$_noteTimelineDataIdByCurrentUser,
            NoteSegmentData,
            NoteSegmentData.generateEmpty(null, null),
            'adding summary note',
            'Summary note added.',
          );
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      $_textareaElement: undefined,
      $_summaryNote: null,
    };
  },

  computed: {
    $_summaryNoteSegment() {
      if (this.$_noteTimelineSegmentIdByCurrentUser === null) return null;
      return this.timelineDataSet.getSegment(this.$_noteTimelineSegmentIdByCurrentUser);
    },

    $_noteTimelineDataIdByCurrentUser() {
      let noteTimelineDataIdByCurrentUser = this.timelineDataSet
        .ids
        .find((timelineDataId) => {
          let timelineData = this.timelineDataSet[timelineDataId];
          if (timelineData.segmentDataType === NoteSegmentData) {
            return timelineData.authorId === this.annotatorId;
          }
        });
      return (noteTimelineDataIdByCurrentUser === undefined)? null : noteTimelineDataIdByCurrentUser;
    },

    $_summaryNoteSegmentId() {
      if (this.$_noteTimelineDataIdByCurrentUser === null) return null;
      let allReferences = referencePool.getAllReferences();
      let noteTimelineDataByCurrentUser = this.timelineDataSet[this.$_noteTimelineDataIdByCurrentUser];
      let summaryNoteSegmentId = Object.keys(noteTimelineDataByCurrentUser.segments)
        .find(segmentId => {
          let segment = noteTimelineDataByCurrentUser.segments[segmentId];
          let timelineSegmentId = new TimelineSegmentId(this.$_noteTimelineDataIdByCurrentUser, segmentId);
          for (let reference of Object.values(allReferences)) {
            if (reference.referFrom.isSameAs(timelineSegmentId)) return false;
          }
          return (segment.begin === null) && (segment.end === null);
        });
      return (summaryNoteSegmentId === undefined)? null : summaryNoteSegmentId;
    },

    $_noteTimelineSegmentIdByCurrentUser() {
      if (this.$_noteTimelineDataIdByCurrentUser === null) return null;
      if (this.$_summaryNoteSegmentId === null) return null;
      return new TimelineSegmentId(
        this.$_noteTimelineDataIdByCurrentUser,
        this.$_summaryNoteSegmentId,
      );
    },
  },

  inject: providedFunctions,

  mounted() {
    this.$data.$_textareaElement = this.$refs.summaryTextarea.$refs.input;
    this.$_updateHeight();
  },

  methods: {
    /* private */
    $_saveSummaryNote() {
      let noteSegment = this.$_summaryNoteSegment.clone();
      noteSegment.data.text = this.$data.$_summaryNote;
      this.setSegment(
        this.$_noteTimelineSegmentIdByCurrentUser,
        NoteSegmentData,
        noteSegment,
        'Summary note set.',
        'setting summary note',
      );
    },

    $_updateHeight() {
      this.$data.$_textareaElement.style.height = '';
      this.$nextTick(() => {
        this.$data.$_textareaElement.style.height = `${this.$data.$_textareaElement.scrollHeight}px`;
      });
    },
  }
}
</script>